module.exports = __webpack_public_path__ + "static/media/pc-weixin.87009391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc-weixin.png
// module id = 2703
// module chunks = 2